import * as React from 'react';
import * as classNames from 'classnames';

import {
    checkbox as cssCheckbox,
    input    as cssInput,
    check    as cssCheck,
} from './checkbox.module.sass';

export const Checkbox: React.SFC<React.InputHTMLAttributes<HTMLInputElement>> = (
    {className, ...props}
) => (
    <span className={classNames(cssCheckbox, className)}>
        <input className={cssInput} type='checkbox' {...props} />
        <span className={cssCheck}></span>
    </span>
);
